import React, {useState, useEffect} from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Card } from 'react-bootstrap'
import { toast } from 'react-toastify';
import axios from 'api/axios';
import moment from 'moment/moment';
import Swal from 'sweetalert2'

import PageHeader from 'components/common/PageHeader';
import ModalAlert from 'components/mycomponents/ModalAlert';

import { dateTimeDatabase } from 'utils/FormatDate';

import ChattingForm from './ChattingForm';

import { io } from 'socket.io-client';
// const socket = io('http://192.168.1.109:3012');
const socket = io('https://websocket-chatting.pohonmedia.com/');

const Chatting = () => {
    // Declare State Variable
    const [showChatingForm, setShowChatingForm] = useState(false);
    const [dataMessage, setDataMessage] = useState([]);
    const [dataConversation, setDataConversation] = useState({intid: 0, intstatus: 0});
    const [message, setMessage] = useState('');
    const [keyword, setKeyword] = useState({q:'', reportTime:1, reportMonth: moment().format('M'), reportYear: moment().format('YYYY'), fromDate: moment().format('YYYY-MM-DD'), toDate: moment().format('YYYY-MM-DD')});
    const [showAlert, setShowAlert] = useState({show: false, message: '', type: '', confirmButton: false});
    const [scrollToBottom, setScrollToBottom] = useState(false);

    // Declare Constant Variable
    const navigate = useNavigate();
    const DATA_URL = '/conversation';
    const ACCESS_USER = JSON.parse(localStorage.getItem('accessUser'));
    const TOKEN_APP = ACCESS_USER ? ACCESS_USER.token : '';
    const USERID = ACCESS_USER ? ACCESS_USER.user_id : '0';
    const HEADER_AUTHORIZATION = {
        headers: {
          'Authorization': `Bearer ${TOKEN_APP}`
        }
    };

    const { intid, token } = useParams();

    // Get Data On Load
    useEffect(() => {
        // getData();
        handleChatting(intid);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const keywordParam = urlParams.get('q');
        const fromDateParam = urlParams.get('from');
        const toDateParam = urlParams.get('to');
        const reportTimeParam = urlParams.get('rt');
        const reportMonthParam = urlParams.get('m');
        const reportYearParam = urlParams.get('y');

        const keywordValue = keywordParam ? keywordParam : '';
        const fromDateValue = fromDateParam ? fromDateParam : moment().format('YYYY-MM-DD');
        const toDateValue = toDateParam ? toDateParam : moment().format('YYYY-MM-DD');
        const reportTimeValue = reportTimeParam ? reportTimeParam : 1;
        const reportMonthValue = reportMonthParam ? reportMonthParam : moment().format('M');
        const reportYearValue = reportYearParam ? reportYearParam : moment().format('YYYY');

        let keywordTemp = keyword;
        keywordTemp.q = keywordValue
        keywordTemp.fromDate = fromDateValue
        keywordTemp.toDate = toDateValue
        keywordTemp.toDate = toDateValue
        keywordTemp.reportTime = reportTimeValue
        keywordTemp.reportMonth = reportMonthValue
        keywordTemp.reportYear = reportYearValue
        setKeyword(keywordTemp);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[]);

    const handleToggleChatting = () => {
        setShowChatingForm(!showChatingForm);
    }

    const handleConfirm = (type, intid = 0, status = 0) => {
        let msg = 'Konfirmasi';
        if (type === 'chat') {
            msg = 'Apakah anda akan membalas pesan ini ?';
            if (parseFloat(status) === 1 || parseFloat(status) === 2) {
                handleChatting(intid);
                return;
            }
        }
        if (type === 'endChat') {
            msg = 'Apakah anda akan mengkahiri pesan ini ?';
        }
        Swal.fire({
            title: "Konfirmasi",
            text: msg,
            icon: "success",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes"
          }).then((result) => {
            if (result.isConfirmed) {
              if (type === 'chat') {
                handleChatting(intid)
              }
              if (type === 'endChat') {
                handleEndChatting(intid)
              }
            }
          });
        return;
    }

    const handleChatting = async (intid) => {
        try {
            const response = await axios.get(`${DATA_URL}/message?conversationId=${intid}&userId=${USERID}`, HEADER_AUTHORIZATION);
            const responseData = response?.data;
            const responseDataResult = responseData?.data;
            
            setDataConversation(responseDataResult);
            setDataMessage(responseDataResult.conversation_message);
            setShowChatingForm(true);
            setScrollToBottom(true);
            
            // setDataDetail(responseDataResult)
            // setShowDetail(true);
        } catch (err) {
            if (err.response) {
                if (err?.response.status === 401) {
                    toast.error(err?.response.data.message);
                    localStorage.removeItem('accessUser');
                    navigate('/login');
                } else {
                    const response = err.response.data;
                    setShowAlert(prevState => { return {...prevState, show: true, message: response.message, type: 'error'} })
                }
            } else {
                setShowAlert(prevState => { return {...prevState, show: true, message: 'Something error with server. Please call administrator or developer.', type: 'error'} })
            }
        }
    }

    const handleEndChatting = async (intid) => {
        try {
            await axios.get(`${DATA_URL}/endChat/${intid}`, HEADER_AUTHORIZATION);
            handleToggleChatting();
            sendMessage('Terima kasih atas laporan anda, kami akan segera menindaklanjuti laporan anda.');
            Swal.fire({
                title: "Berhasil",
                text: "Pesan sudah diakhiri",
                icon: "success",
                showCancelButton: false
            });
        } catch (err) {
            if (err.response) {
                if (err?.response.status === 401) {
                    toast.error(err?.response.data.message);
                    localStorage.removeItem('accessUser');
                    navigate('/login');
                } else {
                    const response = err.response.data;
                    setShowAlert(prevState => { return {...prevState, show: true, message: response.message, type: 'error'} })
                }
            } else {
                setShowAlert(prevState => { return {...prevState, show: true, message: 'Something error with server. Please call administrator or developer.', type: 'error'} })
            }
        }
    }

    const handleChangeForm = (event, state = '') => {
        const {value, name} = event.target;
        if (state === 'keyword') {
            setKeyword(prevState => {
                return {...prevState, [name]: value};
            })
        } else if (state === 'message') {
            setMessage(value);
        } else if (name === 'limit') {
            const page = 1;
            const keywordSearch = keyword;
            const pathUrl = window.location.pathname;
            const urlNavigate = `${pathUrl}?q=${keywordSearch}&page=${page}`
            navigate(urlNavigate);
        }
    }

    const handleConfirmAlert = () => {
        setShowAlert(prevState => { return {...prevState, show: false}});
    }

    const sendMessage = async (messageText = '') => {
        const messageSend = messageText !== '' ? messageText : message;
        let dataMessageTemp = {
            intid: 0,
            intconverstion_id: dataConversation ? dataConversation.intid : 0,
            intsender_id: USERID,
            vcmessage: messageSend,
            dtadd: dateTimeDatabase(),
            intstatus:0,
            intis_admin:1
        };

        try {
            const response = await axios.post(`${DATA_URL}/message`, dataMessageTemp, HEADER_AUTHORIZATION);
            const responseData = response?.data;
            const responseDataResult = responseData?.data;
            console.log(responseDataResult);
            
            // setDataDetail(responseDataResult)
            // setShowDetail(true);
            const emitData = {
                'id': dataConversation ? dataConversation.token_member : '0',
                'message':JSON.stringify(dataMessageTemp)
            }
            socket.emit('message', emitData);
        } catch (err) {
            if (err.response) {
                if (err?.response.status === 401) {
                    toast.error(err?.response.data.message);
                    localStorage.removeItem('accessUser');
                    navigate('/login');
                } else {
                    const response = err.response.data;
                    setShowAlert(prevState => { return {...prevState, show: true, message: response.message, type: 'error'} })
                }
            } else {
                setShowAlert(prevState => { return {...prevState, show: true, message: 'Something error with server. Please call administrator or developer.', type: 'error'} })
            }
        }
        
        setMessage('');
        setDataMessage(prevState => [...prevState, dataMessageTemp]);
        setScrollToBottom(true);
    }

    const handleSocketMessage = (msg) => {
        console.log(msg);
        console.log(dataConversation);
        setDataMessage(prevState => [...prevState, JSON.parse(msg)]);
        setScrollToBottom(true);
    }

    useEffect(() => {
        console.log(dataConversation);
        
        socket.on(token, (msg) => {
            handleSocketMessage(msg);
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[])

    return (
        <>
            {/* Page Header */}
            <PageHeader
                title="Pesan Pengaduan"
                description=""
                className="mb-3"
            >
            </PageHeader>

            {/* Data */}
            <Card>
                <Card.Body style={{height: '75vh'}}>
                    <ChattingForm
                        show={showChatingForm}
                        handleClose={() => navigate('/operasional/complaint')}
                        scrollToBottom={scrollToBottom}
                        setScrollToBottom={setScrollToBottom}
                        dataMessage={dataMessage}
                        dataConversation={dataConversation}
                        message={message}
                        handleChange={handleChangeForm}
                        sendMessage={sendMessage}
                        handleConfirm={handleConfirm}
                    />
                </Card.Body>
            </Card>

            <ModalAlert 
                type={showAlert.type}
                show={showAlert.show}
                message={showAlert.message}
                onHide={() => setShowAlert(prevState => { return {...prevState, show: false} })}
                onConfirm={handleConfirmAlert}
                confirmButton={showAlert.confirmButton}
            />
        </>
    )
}

Chatting.propTypes = {}

export default Chatting;